<template>
  <div>
    <div class="d-flex mb-3 pb-1 align-items-center">
      <div style="margin-right: 10px">Datum:</div>
      <DateRange :update="dateRange" />
    </div>
    <div class="d-flex mb-3 pb-1 justify-content-between">
      <div class="d-flex align-items-center">
        <div style="margin-right: 10px">Bereich:</div>
        <b-form-input id="area" v-model="formData.area" type="text" class="form-control" :placeholder="'Bereich' | i18n" size="sm" />
      </div>
      <div class="d-flex align-items-center">
        <div style="margin-right: 10px">Datum:</div>
        <b-form-input id="date" v-model="formData.date" type="text" class="form-control" :placeholder="'Date' | i18n" size="sm" />
      </div>
    </div>
    <div>
      <div class="inputWrapper">
        <div style="width: 50%; flex-shrink: 0; flex-grow: 1">Angenommene Müllmenge:</div>
        <b-form-input
          style="width: 50%; flex-shrink: 0; flex-grow: 1"
          id="acceptedAmountOfWaste"
          v-model="formData.acceptedAmountOfWaste"
          type="text"
          class="form-control"
          :placeholder="''"
          size="sm"
        />
      </div>
      <div class="inputWrapper">
        <div style="width: 50%; flex-shrink: 0; flex-grow: 1">Anzahl Probenahmen:</div>
        <b-form-input
          style="width: 50%; flex-shrink: 0; flex-grow: 1"
          id="numberOfVisualInspections"
          v-model="formData.numberOfVisualInspections"
          type="number"
          class="form-control"
          :placeholder="''"
          size="sm"
        />
      </div>
      <div class="inputWrapper">
        <div style="width: 50%; flex-shrink: 0; flex-grow: 1">Anzahl Probenahme:</div>
        <b-form-input
          style="width: 50%; flex-shrink: 0; flex-grow: 1"
          id="numberOfSamplesTaken"
          v-model="formData.numberOfSamplesTaken"
          type="number"
          class="form-control"
          :placeholder="''"
          size="sm"
        />
      </div>
      <div class="inputWrapper">
        <div style="width: 50%; flex-shrink: 0; flex-grow: 1">Verbrannte Müllmenge:</div>
        <b-form-input
          style="width: 50%; flex-shrink: 0; flex-grow: 1"
          id="burnedAmountOfWaste"
          v-model="formData.burnedAmountOfWaste"
          type="number"
          class="form-control"
          :placeholder="''"
          size="sm"
        />
      </div>
      <div class="inputWrapper">
        <div style="width: 50%; flex-shrink: 0; flex-grow: 1">Kesselbetriebsstunden K1</div>
        <b-form-input
          style="width: 50%; flex-shrink: 0; flex-grow: 1"
          id="boilerOperatingHoursK1"
          v-model="formData.boilerOperatingHoursK1"
          type="number"
          class="form-control"
          :placeholder="''"
          size="sm"
        />
      </div>
      <div class="inputWrapper">
        <div style="width: 50%; flex-shrink: 0; flex-grow: 1">Kesselbetriebsstunden K2</div>
        <b-form-input
          style="width: 50%; flex-shrink: 0; flex-grow: 1"
          id="boilerOperatingHoursK2"
          v-model="formData.boilerOperatingHoursK2"
          type="number"
          class="form-control"
          :placeholder="''"
          size="sm"
        />
      </div>
      <div class="inputWrapper">
        <div style="width: 50%; flex-shrink: 0; flex-grow: 1">Kesselbetriebsstunden K3</div>
        <b-form-input
          style="width: 50%; flex-shrink: 0; flex-grow: 1"
          id="boilerOperatingHoursK3"
          v-model="formData.boilerOperatingHoursK3"
          type="number"
          class="form-control"
          :placeholder="''"
          size="sm"
        />
      </div>
      <div class="inputWrapper">
        <div style="width: 50%; flex-shrink: 0; flex-grow: 1">Kesselbetriebsstunden K4</div>
        <b-form-input
          style="width: 50%; flex-shrink: 0; flex-grow: 1"
          id="boilerOperatingHoursK4"
          v-model="formData.boilerOperatingHoursK4"
          type="number"
          class="form-control"
          :placeholder="''"
          size="sm"
        />
      </div>
      <div class="inputWrapper">
        <div style="width: 50%; flex-shrink: 0; flex-grow: 1">Heizwert Kessel 1-4</div>
        <b-form-input
          style="width: 50%; flex-shrink: 0; flex-grow: 1"
          id="boilerHeatingValue"
          v-model="formData.boilerHeatingValue"
          type="number"
          class="form-control"
          :placeholder="''"
          size="sm"
        />
      </div>
      <div class="inputWrapper">
        <div style="width: 50%; flex-shrink: 0; flex-grow: 1">Bunkerstand am {{ date }}:</div>
        <b-form-input
          style="width: 50%; flex-shrink: 0; flex-grow: 1"
          id="bunkerStand"
          v-model="formData.bunkerStand"
          type="text"
          class="form-control"
          :placeholder="''"
          size="sm"
        />
      </div>
    </div>
    <div style="position: relative">
      <div style="position: absolute; top: 12px; left: 12px; z-index: 10000000">Besondere Vorkommnisse:</div>
      <Textarea v-model="formData.specialIncidents" class="textarea-wrapper" />
    </div>
    <b-button variant="primary" class="btn-sign-in" size="sm" @click="onSubmit">
      {{ 'save' | i18n }}
    </b-button>
  </div>
</template>

<script>
import DateRange from '../../common/date-range';
import Textarea from '../../common/textarea';
import api from '../../../api';
import moment from 'moment';
import axios from 'axios';

export default {
  title: 'Neue Zusammenfassung Betriebstagebuch',
  components: { DateRange, Textarea },
  data() {
    return {
      coverSheer: api.coverSheet,
      formData: {
        date: moment().format('DD.MM.yyyy'),
        area: 'Abfallannahme',
        acceptedAmountOfWaste: '',
        numberOfVisualInspections: '',
        numberOfSamplesTaken: '',
        burnedAmountOfWaste: '',
        boilerOperatingHoursK1: '',
        boilerOperatingHoursK2: '',
        boilerOperatingHoursK3: '',
        boilerOperatingHoursK4: '',
        boilerHeatingValue: '',
        bunkerStand: '',
        specialIncidents: '',
      },
      isFormValid: false,
      startDate: null,
      endDate: null,
      date: moment().endOf('month').format('DD.MM.yyyy'),
    };
  },
  watch: {
    formData: {
      handler: function (value) {
        this.isFormValid =
          typeof value.date === 'string' &&
          value.date !== '' &&
          typeof value.area === 'string' &&
          value.area !== '' &&
          this.endDate &&
          this.startDate;
      },
      deep: true,
    },
    startDate: {
      handler(value) {
        this.isFormValid =
          typeof this.formData.date === 'string' &&
          this.formData.date !== '' &&
          typeof this.formData.area === 'string' &&
          this.formData.area !== '' &&
          this.endDate &&
          value;
      },
      deep: true,
    },
    endDate: {
      handler(value) {
        this.isFormValid =
          typeof this.formData.date === 'string' &&
          this.formData.date !== '' &&
          typeof this.formData.area === 'string' &&
          this.formData.area !== '' &&
          this.startDate &&
          value;
        this.date = moment(value).format('DD.MM.yyyy');
      },
      deep: true,
    },
  },
  async mounted() {
    try {
      const l = this.$veLoading({
        target: document.querySelector('#loading-container'),
        name: 'wave',
      });
      this.setLoadingInstance(l);
      this.startLoading();
      const data = await api.coverSheet.getDataForNewSheet({});

      this.stopLoading();

      this.formData.acceptedAmountOfWaste = data.gesamtmenge.toString();
      this.formData.numberOfSamplesTaken = data.anzahl_probenahmen.toString();
    } catch (error) {
      this.stopLoading();
      console.log('error', error);
    }
  },
  methods: {
    dateRange(d) {
      this.startDate = d.startDate;
      this.endDate = d.endDate;
    },
    async onSubmit(evt) {
      evt.preventDefault();
      try {
        const baseUrl = axios.defaults.baseURL;
        const auth = JSON.parse(localStorage.getItem('auth'));
        const token = auth.access_token;

        fetch(`${baseUrl}/api/v1/gmva/cover-sheet`, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ...this.formData,
            acceptedAmountOfWaste: +this.formData.acceptedAmountOfWaste,
            dateFrom: this.startDate,
            dateTo: this.endDate
          },)
        });
        this.$router.go(-1);
      } catch (error) {
        console.log('error', error);
      }
    },
    setLoadingInstance(loadingInstance) {
      this.loadingInstance = loadingInstance;
    },
    startLoading() {
      this.loadingInstance.show();
    },
    stopLoading() {
      this.loadingInstance.close();
    },
  },
};
</script>

<style lang="scss">
.inputWrapper {
  display: flex;
  align-items: center;
  padding: 5px 10px;
}
.textarea-wrapper {
  div {
    div {
      textarea {
        padding: 40px 12px 12px !important;
      }
    }
  }
}
</style>
